import { ObjectHelpers } from "../../helpers/object-helpers";

export class ChartRequirementModel {
    public allLongRequirements = false;
    public allShortRequirements = false;
    public longAccountName = '';
    public shortAccountName = '';
    
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}